import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { isEventNotificationDetails as typeGuard } from "@scrile/api-provider/dist/projects/scrileConnect/EventPostProvider";

export { default } from "./NotificationEvent.vue";

export const selector = (item: Notification): boolean => {
  return typeGuard(item.details);
};
